module.exports = __webpack_public_path__ + "img/DTM.ed9dbac8.svg";